// extracted by mini-css-extract-plugin
export default {"qrReader":"LXT_lYs9LE28nlUnXJJ8","qrBox":"CoGWTaQh3788_7QSe_xk"};